import { MODAL_ROW_GROUP_STYLES } from "../index";
import { DETAILS_SECTION_STYLES, DIVIDED_STYLES } from "./styles";

export const detailsBlockStyles = (showInSlideOver?: boolean) => ({
  detailsGroupStyles: showInSlideOver
    ? DETAILS_SECTION_STYLES
    : `rounded bg-stone-50 dark:bg-stone-800 sm:rounded-lg ${DIVIDED_STYLES}`,
  detailsSwitchableStyles: showInSlideOver ? undefined : "",
  detailsRowStyles: showInSlideOver ? MODAL_ROW_GROUP_STYLES : "",
  customWrapperStyles: showInSlideOver ? undefined : "",
});
